<template>
	<div class="aboutBox">

		<div class="max-aboutBox">
			<div class="aboutBox-banner">
				<div class="aboutBox-banner-in">
					<div class="aboutBox-banner-in-logo"></div>
				</div>
			</div>

			<div class="aboutBox-textbox">
				<div class="aboutBox-textbox-a">
					{{aboutData.title}}
				</div>
				<div class="aboutBox-textbox-b" v-html="aboutData.maincontent"></div>
				<!-- <div class="aboutBox-textbox-c">
					<div class="aboutBox-textbox-c-item">
						<div class="aboutBox-textbox-c-item-top">2012</div>
						<div class="aboutBox-textbox-c-item-bottom">我们成立于2012年</div>
					</div>
					<div class="aboutBox-textbox-c-item">
						<div class="aboutBox-textbox-c-item-top sss">【责任 智慧 创新】</div>
					</div>
					<div class="aboutBox-textbox-c-item">
						<div class="aboutBox-textbox-c-item-top">56</div>
						<div class="aboutBox-textbox-c-item-bottom">我们共获得56个专利</div>
					</div>
				</div>
				<div class="aboutBox-textbox-d">发展历程</div>
				<div class="aboutBox-textbox-e">2017年，公司被评为国家级高新技术企业，新时代的先驱者。</div>
				<div class="aboutBox-textbox-e">2017年，公司被评为国家级高新技术企业，新时代的先驱者。</div>
				<div class="aboutBox-textbox-e">2017年，公司被评为国家级高新技术企业，新时代的先驱者。</div> -->
				<!-- <div style="height:100px"></div> -->
			</div>

			<PageBottom />
		</div>

		<div class="min-aboutBox">
			
			<div class="min-caseBox-top-top">
				<!-- <div class="min-caseBox-top-icon"></div> -->
				关于我们
			</div>
			
			<div class="aboutBox-textbox-a" style="fontSize: 16px; margin-bottom: 15px; margin-top: 64px; text-align: center;">
				{{aboutData.title}}
			</div>
			
			<div class="min-home-lianxiwm">
				<div class="pageBottom-in-c-item pageBottom-in-c-item-tit">联系我们</div>
				<div class="pageBottom-in-c-item">{{$store.state.contact.address}}</div>
				<div class="pageBottom-in-c-item">{{$store.state.contact.tellphone}}</div>
				<div class="pageBottom-in-c-item">{{$store.state.contact.fax}}</div>
				<div class="pageBottom-in-c-item">{{$store.state.contact.phone}}</div>
			</div>
			
			<div class="aboutBox-textbox-b" v-html="aboutData.content"></div>
			
		</div>
	</div>
</template>

<script>
	import PageBottom from '@/components/PageBottom.vue'
	export default {
		name: 'Home',
		components: {
			PageBottom
		},
		data() {
			return {
				aboutData: {},
			}
		},
		mounted() { //声明周期
			let that = this;
			window.pageYOffset = 0;
			document.documentElement.scrollTop = 0;
			document.body.scrollTop = 0

			//获取联系我们数据
			that.$axios.post('http://www.sy-eray.com/index.php/api/demo/gywm', {
				// 'aa':1
			}).then(function(response) {
				that.aboutData = response.data.data;
				console.log(that.aboutData)

			}).catch(function(error) {
				console.log(error);
			});

		},
		methods: {

		}
	}
</script>

<style>
	.aboutBox {
		background: #fafafa;
	}

	.aboutBox-banner {
		width: 100%;
		height: 480px;
		background-image: url(../assets/fuwuBg.jpg);
		background-size: 100% 100%;
	}

	.aboutBox-banner-in {
		width: 1200px;
		height: 100%;
		margin: 0 auto;
		position: relative;
	}

	.aboutBox-banner-in-logo {
		width: 485px;
		height: 70px;
		background-image: url(../assets/guanyuwmTit.png);
		background-size: 100% 100%;
		position: absolute;
		top: 250px;
		left: 0;
	}

	.aboutBox-textbox {
		width: 1200px;
		height: auto;
		margin: 0 auto;
	}

	.aboutBox-textbox-a {
		width: 100%;
		height: auto;
		font-size: 18px;
		/* font-weight: bold; */
		color: #353535;
		margin-top: 100px;
		box-sizing: border-box;
	}

	.aboutBox-textbox-b {
		width: 100%;
		height: auto;
		font-size: 18px;
		/* font-weight: bold; */
		color: #666666;
		margin-top: 30px;
		margin-bottom: 100px;
		line-height: 28px;
		box-sizing: border-box;
	}

	.aboutBox-textbox-c {
		width: 100%;
		height: 220px;
		background: #ffffff;
	}

	.aboutBox-textbox-c-item {
		width: calc(100% / 3);
		height: 100%;
		/* background: pink; */
		float: left;
		text-align: center;
	}

	.aboutBox-textbox-c-item-top {
		width: 100%;
		height: auto;
		font-size: 80px;
		color: #19b7c8;
		/* font-weight: bold; */
		padding-top: 54px;
		/* padding-bottom: 5px; */
		box-sizing: border-box;
	}

	.aboutBox-textbox-c-item-bottom {
		width: 100%;
		height: auto;
		font-size: 18px;
		color: #888888;
	}

	.sss {
		font-size: 26px;
		padding-top: 90px;
	}

	.aboutBox-textbox-d {
		width: 100%;
		height: auto;
		font-size: 20px;
		/* font-weight: bold; */
		color: #353535;
		margin-top: 100px;
		box-sizing: border-box;
	}

	.aboutBox-textbox-e {
		width: 100%;
		height: auto;
		font-size: 18px;
		/* font-weight: bold; */
		color: #888888;
		margin-top: 20px;
		box-sizing: border-box;
	}

	.min-aboutBox {
		display: none;
	}

	@media only screen and (max-width: 1200px) {
		.aboutBox {
			background: #ffffff;
		}
		.max-aboutBox {
			display: none;
		}

		.min-aboutBox {
			display: block;
			padding: 0 0.9375rem;
			box-sizing: border-box;
			padding-bottom: 3.0625rem;
		}
		.min-caseBox-top-top{
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 2.75rem;
			background: #f8f8f8;
			border-bottom: 0.0625rem solid #ededed;
			box-sizing: border-box;
			text-align: center;
			font-size: 1.125rem;
			color: #353535;
			line-height: 2.75rem;
		}
		
		
	}
</style>
